var _clipPath, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.193,
    xmlns: "http://www.w3.org/2000/svg",
    height: 9.401,
    id: "screenshot-5011512c-14e1-808d-8007-a9ccb20e472a",
    viewBox: "2170.497 -922.487 13.193 9.401",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-5011512c-14e1-808d-8007-a9ccb20e472a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-5011512c-14e1-808d-8007-a9ccb20e472a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2183.6904296875,-920.85498046875L2181.943359375,-914.1256103515625L2180.67333984375,-913.3985595703125L2182.249755859375,-919.4600830078125L2171.04248046875,-913.085693359375L2170.4970703125,-913.9227294921875L2181.70458984375,-920.2969970703125L2175.201416015625,-921.76806640625L2176.47119140625,-922.4866943359375L2183.6904296875,-920.85498046875Z",
    className: "cls-1",
    style: {
      fill: "#100f0f",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-544258f1-fab9-805a-8007-de082e4bc73a-5011512c-14e1-808d-8007-a9ccb20e472a"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-3666-5011512c-14e1-808d-8007-a9ccb20e472a-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3666-5011512c-14e1-808d-8007-a9ccb20e472a-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2183.6904296875,-920.85498046875L2181.943359375,-914.1256103515625L2180.67333984375,-913.3985595703125L2182.249755859375,-919.4600830078125L2171.04248046875,-913.085693359375L2170.4970703125,-913.9227294921875L2181.70458984375,-920.2969970703125L2175.201416015625,-921.76806640625L2176.47119140625,-922.4866943359375L2183.6904296875,-920.85498046875Z",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 2,
      stroke: "#000000",
      strokeOpacity: 1
    },
    id: "stroke-shape-render-3666-5011512c-14e1-808d-8007-a9ccb20e472a-0"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3666-5011512c-14e1-808d-8007-a9ccb20e472a-0",
    clipPath: "url('#inner-stroke-render-3666-5011512c-14e1-808d-8007-a9ccb20e472a-0')"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartArrowIcon);
export default __webpack_public_path__ + "static/media/StartArrowIcon.743ef7dbcaf2b573969dc73321c70d17.svg";
export { ForwardRef as ReactComponent };